import React, { useEffect, useState } from 'react';
import axios from 'axios';
import ParentComponent from '../hoc/ParentComponent';
import useToken from '../context/useToken';

const BrandSolutions = () => {
  const token = useToken()
  const [pageInfo, setPageInfo] = useState({});

  const fetchPageInfo = async () => {
    try {
      const response = await axios.get('https://thecfagroup.org/v1/api/webpages/67927078553290a16636075c', {
      });
      setPageInfo(response.data);
    } catch (error) {
      console.error('Error fetching page information:', error);
      setPageInfo((prevInfo) => ({
        ...prevInfo,
        description: 'Failed to load page information.',
      }));
    }
  };

  useEffect(() => {
    fetchPageInfo();
  }, [token]);

  if(pageInfo)
  {
    return (
      <ParentComponent
      id="672b3662c45fc25dfdd2adeb"
      img={pageInfo.image}
      title={pageInfo.title}
      subtitle={pageInfo.subtitle}
      description={pageInfo.description}
      fetchPageInfo={fetchPageInfo}
      />
    );
  }
};

export default BrandSolutions;
